
    <a
      id="navigateBackToList"
      [routerLink]="redirectTo$ | async"
      [queryParams]="queryParams$  | async"
      [ngClass]="['btn',cstmClass]"
    >
      <fa-icon *ngIf="icon" [icon]="['fas', icon]" class="mr-1"></fa-icon> {{ label | translate }}
    </a>
  